import axios from 'axios'
import { authHeader } from '../_helpers'
import { cancelSource } from '../_helpers/cancelToken'

const state = {
  atkAccounts: [],
  loading: true
}

const mutations = {
  getAccountsSuccess (state, data) {
    state.atkAccounts = data
    state.loading = false
  },
  getLoadingStart (state) {
    state.loading = true
  },
  getLoadingEnd (state) {
    state.loading = false
  }

}

const actions = {
  getAccounts ({ commit, dispatch }) {
    dispatch('alert/clear', null, { root: true })
    commit('getLoadingStart')
    cancelSource.cancel()
    cancelSource.setSource(axios.CancelToken.source())
    axios.get(process.env.VUE_APP_URL + 'accounts/api/accounts', { headers: authHeader(), cancelToken: cancelSource.getSource().token })
      .then(responce => {
        commit('getAccountsSuccess', responce.data)
        commit('getLoadingEnd')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        var errorCode = error.response.status
        switch (errorCode) {
          // case 400:
          //   dispatch('alert/error', 'Произошла ошибка:' + ' Ошибка загрузки данных. Проверьте токен доступа системы топливных карт', { root: true })
          //   break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
        commit('getLoadingEnd')
        dispatch('alert/error', 'Произошла ошибка: ' + error, { root: true })
      })
  },
  createAccount ({ dispatch }, data) {
    dispatch('alert/clear', null, { root: true })
    axios.post(process.env.VUE_APP_URL + 'accounts/api/accounts', data, { headers: authHeader() })
      .then(responce => {
        dispatch('alert/success', 'Система мониторинга успешно добавлена', { root: true })
        dispatch('getAccounts')
      })
      .catch(error => {
        var errorCode = error.response.status
        switch (errorCode) {
          // case 400:
          //   dispatch('alert/error', 'Произошла ошибка:' + ' Ошибка загрузки данных. Проверьте токен доступа системы топливных карт', { root: true })
          //   break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
        dispatch('alert/error', 'Произошла ошибка: ' + error, { root: true })
        dispatch('getAccounts')
      })
  },
  deleteAccount ({ dispatch }, id) {
    dispatch('alert/clear', null, { root: true })
    axios.delete(process.env.VUE_APP_URL + `accounts/api/accounts/${id}`, { headers: authHeader() })
      .then(responce => {
        dispatch('alert/success', 'Система мониторинга успешно удалена', { root: true })
        dispatch('getAccounts')
      })
      .catch(error => {
        var errorCode = error.response.status
        switch (errorCode) {
          // case 400:
          //   dispatch('alert/error', 'Произошла ошибка:' + ' Ошибка загрузки данных. Проверьте токен доступа системы топливных карт', { root: true })
          //   break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
        dispatch('alert/error', 'Произошла ошибка: ' + error, { root: true })
        dispatch('getAccounts')
      })
  }
}

export const AtkAccount = {
  namespaced: true,
  state,
  mutations,
  actions
}
